import updateAndValidateReduxAction from 'modules/redux/actions/update-and-validate'
import { TRAINING_AUTH_DOMAIN } from 'modules/training/modules/app-auth/constants'

function updateTrainingAuthAction (params) {
  return updateAndValidateReduxAction({
    type: params.type,
    payload: {
      path: TRAINING_AUTH_DOMAIN,
      ...params.payload
    }
  })
}

export default updateTrainingAuthAction
